export const ACCEPT_FILE_TYPES = ['audio/mp3'];
export const ACCEPT_FILE_EXTENSIONS = ['.mp3'];
